<template>
    <tippy :interactive="false"
           :id="tippyIdUnique"
           :arrow="true"
           placement="bottom"
           trigger="focusin"
           hideOnClick="false"
           theme="fnfTippy"
           animation="fade"
           maxWidth="300px"
           distance="1"
           style="margin-top:0">

        <i role="tooltip" :aria-labelledby="tooltipDesc" tabindex="0" class="Tooltip__Toggle Icon Icon__help u-paddingLeft1">
            <span class="u-visuallyhidden" :id="tooltipDesc">
                {{ $t('tooltip.ToolTipReader') }}
            </span>
        </i>
        <template #content>
            <div style="text-align: left">
                <p class="u-textCaption" v-html="tippyTitle"></p>
                <div style="font-size:11px" v-html="tippyText"></div>
            </div>
        </template>
    </tippy>
</template>

<script>
    import 'tippy.js/dist/tippy.css';
    import 'tippy.js/themes/light.css';
    import 'tippy.js/dist/backdrop.css'
    import { Tippy } from 'vue-tippy';
    import { createApp, ref } from 'vue';
    import { createI18n, useI18n } from 'vue-i18n';
    import { languages } from '../../translations/index.js'

    const messages = Object.assign(languages);

    const i18n = createI18n({
        locale: 'en', // Set the initial locale
        fallbackLocale: 'en', // set fallback locale
        messages,
    });

    const app = createApp({})

    export default {
        components: {
            Tippy
        },
        props: {
            options: {
                default: () => ({}),
            },
            tippyTitle: String,
            tippyText: {
                type: String,
            },
            tippyNum: {
                default: '1',
                type: String,
            },
        },
        setup() {

            const tooltipDesc = ref('tooltipDesc' + Math.ceil(Math.random() * 100));
            const tippyIdUnique = ref('tippyID' + Math.ceil(Math.random() * 100));
           
            return {
                tooltipDesc,
                tippyIdUnique
            };
        },
    };

    // Use the VueI18n instance
    app.use(i18n)

</script>

<style lang="scss">
    @import "~styles/base/variables";
    @import '../../../local_modules/pikaday/css/pikaday.css';
    @import '../../../local_modules/pikaday/css/theme.css';
    @import '../../../local_modules/pikaday/css/triangle.css';

    .pika-single {
        font: inherit;
        margin-top: 0;
        table-layout: fixed;
    }

    .pika-table {
        margin-top: 0;
        tr, tr:nth-child(odd)

    {
        background-color: #fff;
        border-bottom: 0;
    }

    th {
        color: $brand-color-alternate;
    }

    tr {
        color: $brand-color-alternate;
    }

    td:last-child {
        padding: 0;
    }

    }

    .is-today {
        .pika-button

    {
        background-color: $brand-color-alternate;
        color: $brand-color-primary;
        &:hover

    {
        color: #fff;
    }

    }
    }

    .pika-button {
        background-color: transparent;
        &:hover

    {
        background-color: $brand-color-primary;
        border-radius: 0;
    }

    }

    .is-selected {
        .pika-button

    {
        background-color: $brand-color-alternate;
        border-radius: 0;
        box-shadow: none;
    }

    }

    .pika-prev,
    .pika-next {
        opacity: 1.0;
    }

        .pika-prev.is-disabled, .pika-next.is-disabled {
            opacity: 1.0;
        }

    .is-disabled .pika-button,
    .is-inrange .pika-button {
        background-color: $brand-color-alternate;
        color: #ccc;
        opacity: 1.0;
    }
</style>

